import React from "react";

/** Section wrapper with consistent dark page spacing. */
export default function DarkSection({ id, ariaLabelledby, className = "", children }) {
  return (
    <section
      id={id}
      aria-labelledby={ariaLabelledby}
      className={`max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16 ${className}`}
    >
      {children}
    </section>
  );
}
